









import { Component, Prop, Vue } from "vue-property-decorator";
import CzCard from "../cz/CzCard.vue";
import CzChip from "../cz/CzChip.vue";
import CzTitle from "../cz/CzTitle.vue";

@Component({ components: { CzCard, CzChip, CzTitle } })
export default class ProgramHero extends Vue {
  @Prop({ type: String, default: "" }) tag!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) description!: string;
}
